<template>
  <b-modal
    ref="modal"
    title="Delete Selected Folders/Files"
    centered
    @hide="closeHandler"
  >
    <template #modal-footer>
      <ButtonPrimary
        variant="primary"
        @click="accept"
      >
        Yes
      </ButtonPrimary>
      <ButtonOutline
        variant="outline-primary"
        @click="$refs.modal.hide()"
      >
        No
      </ButtonOutline>
    </template>

    Are you sure you want to delete selected items({{ selectedCount }})?
    This action cannot be undone.
  </b-modal>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import mixin from "./mixin";
import ButtonPrimary from "../../../common/atoms/ButtonPrimary.vue";
import ButtonOutline from "../../../common/atoms/ButtonOutline.vue";

const { mapGetters, mapActions } = createNamespacedHelpers('fileBrowser')

export default {
  name: "DeleteSelectedItemModal",
  components: {ButtonOutline, ButtonPrimary},
  mixins: [mixin],
  computed: {
    ...mapGetters(['selectedCount'])
  },
  methods: {
    ...mapActions(['deleteSelectedItem']),
    accept() {
      this.deleteSelectedItem()
      this.$refs.modal.hide()
    }
  }
}
</script>

<style scoped lang="scss">

</style>